<ng-container *transloco="let t;">

    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{ t('Upload files modal title (upload modal) - Upload files') }}
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="documentUploadFileModalClose('close')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body p-0" tabindex="0" ngbAutofocus>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">

                        <form class="documentFileUploadModalWrapper" #form="ngForm" [formGroup]="uploadForm">
                            <app-upload-files [acceptableFiles]="acceptDocumentFileTypes" [maxFileSize]="maxDocumentUploadSize" [section]="'document'" [formArrayName]="'files'" [actionFrom]="'document_section'"
                                              class="d-flex"></app-upload-files>

                            <div class="modal-footer justify-content-end px-50 py-2">
                                <div class="m-0">
                                    <button type="button" class="btn btn-outline-secondary me-50"
                                            [disabled]="uploadForm.invalid"
                                            (click)="documentUploadFileModalClose('close')"
                                            rippleEffect>
                                        {{ t('Cancel button text (cancel button) - cancel') }}
                                    </button>
                                    <button type="submit" class="btn btn-success" rippleEffect (click)="onUploadClick()"
                                            [disabled]="form.invalid">
                                        {{ t('Upload button (upload modal) - Upload') }}
                                    </button>
                                </div>
                            </div>
                        </form>

                </div>
            </div>
        </div>
    </div>
</ng-container>
